var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 14.5488,
    cy: 14.7969,
    r: 14,
    fill: "#2797E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4164_32808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54883 14.7969C8.54883 11.4831 11.235 8.79688 14.5488 8.79688C17.8626 8.79688 20.5488 11.4831 20.5488 14.7969C20.5488 18.1107 17.8626 20.7969 14.5488 20.7969C11.235 20.7969 8.54883 18.1107 8.54883 14.7969ZM15.1488 12.3969C15.1488 12.2377 15.0856 12.0851 14.9731 11.9726C14.8606 11.8601 14.708 11.7969 14.5488 11.7969C14.3897 11.7969 14.2371 11.8601 14.1246 11.9726C14.012 12.0851 13.9488 12.2377 13.9488 12.3969C13.9488 12.556 14.012 12.7086 14.1246 12.8211C14.2371 12.9337 14.3897 12.9969 14.5488 12.9969C14.708 12.9969 14.8606 12.9337 14.9731 12.8211C15.0856 12.7086 15.1488 12.556 15.1488 12.3969ZM14.5488 17.7969C14.708 17.7969 14.8606 17.7337 14.9731 17.6211C15.0856 17.5086 15.1488 17.356 15.1488 17.1969V14.7969C15.1488 14.6377 15.0856 14.4851 14.9731 14.3726C14.8606 14.2601 14.708 14.1969 14.5488 14.1969C14.3897 14.1969 14.2371 14.2601 14.1246 14.3726C14.012 14.4851 13.9488 14.6377 13.9488 14.7969V17.1969C13.9488 17.356 14.012 17.5086 14.1246 17.6211C14.2371 17.7337 14.3897 17.7969 14.5488 17.7969Z",
    fill: "#2797E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4164_32808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8.54883 8.79688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/Info-Icon.9304869628d394cf3ddd82b34a6651de.svg";
export { ForwardRef as ReactComponent };